import type { PageableRangeInput } from '@allocab/allocab-extranet-api-types';
import type { ListOutput } from '@allocab/allocab-standard-shared-types';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

import type { ExtranetRidesListInput, ExtranetTripOutput } from '../../../types/extranet-api.types';
import { getExtranetApi } from '../extranetApi';
import { toPageableRangeInput } from '../mappers';
import { extranetQueryKeys } from '../queryKeys';

// `search`, `sortBy`, `sortDir` ne sont pas (encore) supportés par /v1/trips/ :
// on les conserve dans l'input front pour stabilité d'API, mais ils sont ignorés
// côté call API. Idem pour `status[]` (non géré par le back actuel).
export const useRides = (input: ExtranetRidesListInput) =>
  useQuery<ListOutput<ExtranetTripOutput>>({
    queryKey: extranetQueryKeys.rides.list(input),
    queryFn: () =>
      getExtranetApi().get<PageableRangeInput, ListOutput<ExtranetTripOutput>>(
        '/v1/trips/',
        toPageableRangeInput(input, {
          offset: input.page && input.limit ? (input.page - 1) * input.limit : undefined,
          limit: input.limit,
        }),
      ),
    enabled: Boolean(input.dateRange?.from && input.dateRange?.to),
    placeholderData: keepPreviousData,
  });
